import React from 'react';

export function AboutStory() {
  return (
    <div className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Our Story</h2>
          <div className="prose prose-lg mx-auto text-gray-600">
            <p>
              HireFy was founded with a clear mission: to make equipment hire simple, 
              transparent, and reliable. We understand that finding the right equipment 
              at the right price can be challenging, which is why we've created a platform 
              that connects you with trusted local hire providers.
            </p>
            <p>
              Our platform helps both DIY enthusiasts and professional contractors find 
              the equipment they need, when they need it. We work with verified providers 
              who maintain their equipment to the highest standards, ensuring you get 
              quality tools and machinery for your projects.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}